/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CommunityCliQ API
 *  ## Authentication
 *
 *   Every request must include an API access token generated in the CommunityCliQ \
 *   application:
 *
 *   ```
 *   Authorization: X-API-TOKEN
 *   ```
 *
 * OpenAPI spec version: V2.X
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { CommandErrorResponse, WhoAmiResponse } from "../../model";

import { customInstance } from "../../../lib/SpringAxios";
import type { ErrorType } from "../../../lib/SpringAxios";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") {
      continue;
    }
    Object.defineProperty(result, key, {
      configurable: true,
      enumerable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const whoAmI = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<WhoAmiResponse>(
    { method: "GET", signal, url: `/api/v2/whoami` },
    options,
  );
};

export const getWhoAmIQueryKey = () => {
  return [`/api/v2/whoami`] as const;
};

export const getWhoAmIQueryOptions = <
  TData = Awaited<ReturnType<typeof whoAmI>>,
  TError = ErrorType<CommandErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof whoAmI>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWhoAmIQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof whoAmI>>> = ({
    signal,
  }) => whoAmI(requestOptions, signal);

  return { queryFn, queryKey, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof whoAmI>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WhoAmIQueryResult = NonNullable<Awaited<ReturnType<typeof whoAmI>>>;
export type WhoAmIQueryError = ErrorType<CommandErrorResponse>;

export function useWhoAmI<
  TData = Awaited<ReturnType<typeof whoAmI>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof whoAmI>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof whoAmI>>,
          TError,
          Awaited<ReturnType<typeof whoAmI>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhoAmI<
  TData = Awaited<ReturnType<typeof whoAmI>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof whoAmI>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof whoAmI>>,
          TError,
          Awaited<ReturnType<typeof whoAmI>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhoAmI<
  TData = Awaited<ReturnType<typeof whoAmI>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof whoAmI>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useWhoAmI<
  TData = Awaited<ReturnType<typeof whoAmI>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof whoAmI>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWhoAmIQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
